import matrix from '../matrix'
import legendMatrix from '../legend-matrix'

import {
  arrMatrix1, arrMatrix2, arrMatrix3, arrPopup1, arrPopup2, arrPopup3, arrPopup4, arrPopup5,
  task1, task2, task3, task4, task5,
} from './arr'

export default {
  components: {
    matrix,
    legendMatrix,
  },
  setup() {
    const arrMatrixFull = [arrMatrix1, arrMatrix2, arrMatrix3]
    const arrMatrixRandom = arrMatrixFull[Math.floor(Math.random() * arrMatrixFull.length)]
    // const users = {
    //   0: 'Cлавы',
    //   1: 'Вали',
    //   2: 'Юли',
    //   6: 'Чонгука',
    // }
    // const find = arrMatrixRandom.find(item => item.me)
    // const arrPopupChooseUser = [
    //   { text: `Ого, у Егора точно такие же музыкальные интересы, как и у Толи! Теперь осталось сказать, стоит ли рекомендовать Толе песню ${users[find.author]}.`, buttonTitle: 'Продолжить' },
    // ]

    return {
      arrMatrix: arrMatrixRandom,
      arrPopup1,
      arrPopup2,
      arrPopup3,
      arrPopup4,
      arrPopup5,
      task1,
      task2,
      task3,
      task4,
      task5,
      // arrPopupChooseUser,
    }
  },
}
